import Api from './baseApi';

export default {


    hbStatusGroup: (Order) => {
        let url = "/api/orders/hbStatusGroup?v=1";
        if (Order.startDate)
            url += `&startDate=${Order.startDate}`;
        if (Order.endDate)
            url += `&endDate=${Order.endDate}`;
        return Api.get(url)
    },
    searchOrder: (Order) => {
        let url = "/api/orders/fast?v=1";
        if (Order.search)
            url += `&q=${Order.search}`;
        if (Order.state > -1)
            url += `&state=${Order.state}`;
        if (Order.startDate)
            url += `&startDate=${Order.startDate}`;
        if (Order.endDate)
            url += `&endDate=${Order.endDate}`;
        if (Order.insuranceId > -1)
            url += `&insuranceId=${Order.insuranceId}`;
        if (Order.hbState !== "")
            url += `&status=${Order.hbState}`;
        if (Order.cities && Order.cities.length) {
            Order.cities.forEach(c => {
                if (c) {
                    url += `&city=${encodeURIComponent(c)}`;
                }
            });
        }
        if (Order.isComission)
            url += `&isComission=${Order.isComission}`;

        
        return Api.get(url)
    },
    getOrders: () => Api.get('/api/Orders'),
    getCity: () => Api.get('/api/Orders/City'),
    getOrder: (id) => Api.get(`/api/Orders/${id}`),
    putOrder: (Order) => Api.put(`/api/Orders/${Order.id}`, Order),
    deleteOrder: (Order) => Api.delete(`/api/Orders/${Order.id}`, Order),
    postOrder: (Order) => Api.post(`/api/Orders`, Order),
    bulkUpdateStates: (Model) => {

        let url = `/api/orders/bulkUpdateStates`;
        if (Model.insuranceId > -1)
            url += `?insuranceId=${Model.insuranceId}`
        return Api.patch(url, Model);
    },
    bulkConfirmBarcode: (barcodes) => Api.patch(`/api/orders/bulkConfirmBarcode`, { barcodes }),
    saveInsurance: (Model) => {
        let url = `/api/orders/SendInsurance?insuranceId=${Model.insuranceId}`;
        return Api.patch(url, Model);
    },
    uploadInsurance: (Model) => {
        let url = `/api/Insurances/Upload`;
        return Api.post(url, Model, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
    },


    reSendInvoice: (Model) => Api.patch(`/api/orders/reSendInvoice`, Model),
    
    sendReferenceNumberToIdefix: (packageNumber, refNumber) => {
        console.log('Sending reference number to Idefix:', { packageNumber, refNumber });
        let url = `/api/Idefix/SendReferenceNumberToIdefix?packageNumber=${packageNumber}&refNumber=${refNumber}`;
        return Api.post(url);
    },

    getFraudOrders: () => Api.get('/api/orders/fraud-orders'),

    markFraudSent: (orderNumbers) => Api.post('/api/orders/mark-fraud-sent', { orderNumbers }),

    cancelForIdia: (orderId, packageNumber, note) =>
        Api.post(`/api/Orders/${orderId}/cancel-idia`, { packageNumber, note }),

    retryIdiaCancelNotification: (orderId, note) =>
        Api.post(`/api/Orders/${orderId}/retry-idia-cancel`, { note }),

    getPreviousPayments: (orderNumber) =>
        Api.get('/api/orders/previous-payments', { params: { orderNumber } }),

    getReturnedOrders: (startDate, endDate) =>
        Api.get('/api/orders/returned', { params: { startDate, endDate } }),

    getPendingShipments: (startDate, endDate) =>
        Api.get('/api/orders/pending-shipments', { params: { startDate, endDate } }),

    getLostOrders: (startDate, endDate) =>
        Api.get('/api/orders/lost', { params: { startDate, endDate } }),

    getInsuranceFees: (startDate, endDate, onlyLost) =>
        Api.get('/api/orders/insurance-fees', { params: { startDate, endDate, onlyLost } }),

    markOrderLost: (id, isLost) =>
        Api.post(`/api/orders/${id}/mark-lost`, null, { params: { isLost } }),

    markRefundReceived: (id, received) =>
        Api.post(`/api/orders/${id}/mark-refund`, null, { params: { received } }),

    cancelInvoice: (id) => Api.post(`/api/orders/${id}/cancel-invoice`),

    addCustomerToBlacklist: (email) => Api.post('/api/orders/blacklist/add', { email }),
    removeCustomerFromBlacklist: (email) => Api.post('/api/orders/blacklist/remove', { email }),
    getBlacklistedCustomers: () => Api.get('/api/orders/blacklist/list'),

}